import { Command, enterNode } from '../../utils/tree-operations/commands.ts'
import { makeProjectionStateField } from '../../utils/projection-state-field.ts'

export const documentCommands = makeProjectionStateField<Command>(enterNode)
